require("./../plugins/jquery.lettering");
// require('is-in-viewport');
require( 'waypoints/lib/noframework.waypoints.js' );

$(function () {
    var timer = setInterval( function(){
        if($('body').hasClass('loaded')) {
            clearInterval(timer);
            // console.log('char animation loaded');
            init();
        }
    }, 500);

    function init()
    {
        const selectorString = '.char-animation';

        $(selectorString).each(function () {
            const $this = $(this);
            divideChars($this);

            const waypoint = new Waypoint({
                element: $this[0],
                handler: function (direction) {
                    $this.addClass('in');
                    // console.log('in');
                },
                offset : '75%',
            });

            // const inview = new Waypoint.Inview({
            //     element: $this[0],
            //     exited: function(direction) {
            //         $this.removeClass('in');
            //     },
            // });
        });
    }

    function divideChars(target) {
        const selectorString = '.char-animation';

        target.lettering();
        let line = 1;
        let base = target.find('span').eq(0).offset().top;
        for (var i = 0; i < target.find('span').length; i++) {
            if (target.find('span').eq(i).offset().top > base) {
                base = target.find('span').eq(i).offset().top;
                line++;
            }
            target.find('span').eq(i).data('line', line);
            target.find('span').eq(i).css({
                'transition-delay': (0.9 + (i * 0.05) - (line * 0.6)) + 's'
            });
        }
    }
});

